// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3csvj","location":"Header_location__R62GY"};